module.exports = __webpack_public_path__ + "media/images/mail-4d75eca0b942dc6fe5dbd7ef0f7ca7c0.png";